import { render, staticRenderFns } from "./SentenceList.vue?vue&type=template&id=76946c64&scoped=true&"
import script from "./SentenceList.vue?vue&type=script&lang=js&"
export * from "./SentenceList.vue?vue&type=script&lang=js&"
import style0 from "./SentenceList.vue?vue&type=style&index=0&id=76946c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76946c64",
  null
  
)

export default component.exports